export default __webpack_public_path__ + "static/media/dark-map-image.09ab58e9.PNG";